<template>
  <div>
    <Head title="Customers" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Customers</li>
      </ol>
    </nav>
    <h1>Customers</h1>

    <div class="d-flex justify-content-between mb-3">
      <search-filter v-model="form.search" @reset="reset" />

      <Link class="btn btn-primary" href="/customers/create">
        <span>Create Customer</span>
      </Link>
    </div>

    <!-- <div class="filters">
      <div class="filter-item">
        <select class="form-select" v-model="form.agencies" v-if="agencies.length">
          <option value=""></option>
          <option :value="agency.name" v-for="agency in agencies" :key="agency.id">{{ agency.name }}</option>
        </select>
      </div>
    </div> -->

    <div class="content-box">
      <table class="table">
        <thead>
          <tr>
            <th>ID</th>
            <th v-if="auth.user.role_admin">Agency</th>
            <th>
              <Sort field="first_name" @sort="sort">Firstname</Sort>
            </th>
            <th>
              <Sort field="last_name" @sort="sort">Lastname</Sort>
            </th>
            <th>Company</th>
            <th>
              <Sort field="email" @sort="sort">Email</Sort>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="customer in customers.data" :key="customer.id">
            <td>
              <Link :href="`/customers/${customer.id}/view`">
                {{ customer.id }}
              </Link>
            </td>
            <td v-if="auth.user.role_admin">
              <Link :href="`/customers/${customer.id}/view`">
                {{ customer.agency[0].name }}
              </Link>
            </td>
            <td>
              <Link :href="`/customers/${customer.id}/view`">
                {{ customer.first_name }}
              </Link>
            </td>
            <td>
              <Link :href="`/customers/${customer.id}/view`" tabindex="-1">
                {{ customer.last_name }}<span v-if="customer.middle_name">, {{ customer.middle_name }}</span>
              </Link>
            </td>
            <td>
              <Link :href="`/customers/${customer.id}/view`" tabindex="-1">
                {{ customer.company }}
              </Link>
            </td>
            <td>
              <Link :href="`/customers/${customer.id}/view`" tabindex="-1">
                {{ customer.email }}
              </Link>
            </td>
          </tr>
          <tr v-if="customers.data.length === 0">
            <td colspan="6">No customers found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-3" :links="customers.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import Sort from '@/Shared/Sort'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    Sort
  },
  layout: Layout,
  props: {
    filters: Object,
    customers: Object,
    agencies: Object
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        agencies: this.filters.agencies,
        trashed: this.filters.trashed,
        field: this.filters.field,
        direction: this.filters.direction,
      },
    }
  },
  computed: {
    auth() {
      return this.$page.props.auth
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/customers', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    sort(field) {
      this.form.field = field
      this.form.direction = this.form.direction === 'asc' ? 'desc' : 'asc'
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
